module.exports = __webpack_public_path__ + "static/img/XspaLOGO.11141ff.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/XspaLOGO.png
// module id = yOQk
// module chunks = 1